import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { Popover as i, PopoverTrigger as e, PopoverContent as n, PopoverBody as m } from "@chakra-ui/react";
import { Button as p } from "../../../forms/Button/Button.mjs";
import "../../../forms/Button/IconButton.mjs";
import "../../../forms/Button/ButtonGroup.mjs";
import { ChevronDownIcon as s } from "../../../icons/componentIcons.mjs";
const f = ({ children: o }) => /* @__PURE__ */ t(i, { children: [
  /* @__PURE__ */ r(e, { children: /* @__PURE__ */ r(
    p,
    {
      width: { base: "100%", md: "auto" },
      variant: "tertiary",
      size: "sm",
      rightIcon: /* @__PURE__ */ r(s, { size: "sm", variant: "light" }),
      children: "Filter"
    }
  ) }),
  /* @__PURE__ */ r(n, { children: /* @__PURE__ */ r(m, { children: o }) })
] });
export {
  f as Filter
};
